import { render, staticRenderFns } from "./payment-history.vue?vue&type=template&id=72147262&"
import script from "./payment-history.vue?vue&type=script&lang=js&"
export * from "./payment-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports